import { Link } from "react-router-dom";

import { AppPagePaths } from "App/routes/paths";

import styles from "../ActiveUsers.module.scss";

type ActiveUsersLinkProps = {
    /**
     * Journey ID (required)
     */
    journeyId: string;
    /**
     * Optional Node ID, will limit active query to this nodes users
     */
    nodeId?: string;
    /**
     * Text value to display as link
     */
    text?: string;
    /**
     * child / children element(s) to render as link
     */
    children?: JSX.Element;
};

/**
 * @remarks Should provide 1 of either text or children
 */
export function ActiveUsersLink({ journeyId, nodeId, text, children }: ActiveUsersLinkProps): JSX.Element {
    let href = `${AppPagePaths.journeysUsers}/${journeyId}`;
    if (!!nodeId) {
        href += `/${nodeId}`;
    }

    return (
        <Link to={href} target="_blank" className={styles.linkText}>
            {!!text ? text : children}
        </Link>
    );
}
